export default "__VITE_ASSET__587da492__"